module.exports = __webpack_public_path__ + "img/15.610f0358.png";